<template>
  <t-button @click="handleClick">
    <slot />
  </t-button>
</template>

<script>
import userModule from '@/store/modules/user.module'
const stripePromise = window.Stripe(
  'pk_test_51TqWW5Cm9iOpY3pPJ9NTJxPCEfiaVM6NlXG9Jfs5qtA0qwZ8tpHc0ueMgHW9UeVEzfjyt56EbduA8TuvJtOGuToP00Zgr1MsS0'
)

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true
    }
  },

  computed: {
    user: userModule.user
  },

  methods: {
    async handleClick() {
      const stripe = await stripePromise

      const orderData = {
        name: this.name,
        description: this.description,
        amount: this.amount,
        clientId: this.user.id,
        customerEmail: this.user.email
      }
      const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }

      const response = await fetch(
        'https://europe-west3-carpe-diem-habit-tracker.cloudfunctions.net/createOrderAndSession',
        {
          method: 'POST',
          body: JSON.stringify(orderData),
          headers
        }
      )

      const data = await response.json()
      const body = JSON.parse(data.body)
      const sessionId = body.sessionId

      try {
        stripe.redirectToCheckout({ sessionId })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
